function Summary({ data, state, dispatch, setTab, addToBasket, isSubmitting }) {
    const type = state.plain_or_printed.type;
    const typeData = data.plain_or_printed[type];

    const choice = data.size_and_quantity[`${type}_choices`].find((item) => {
        return item.diameter === state.size_and_quantity.diameter && item.height === state.size_and_quantity.height;
    });

    const totalPrice = choice[`${state.size_and_quantity.quantity}_unit_price`] * state.size_and_quantity.quantity;

    return (
        <div className="tab">
            <div className="cols">
                <div>
                    <img src={choice ? choice.image : data.plain_or_printed[type].image} />
                </div>
                <div>
                    <h1 className="title">{data.product.post_title}</h1>
                    <div className="margin-bottom-2" dangerouslySetInnerHTML={{ __html: typeData.description }}></div>
                    <div className="margin-bottom-2">
                        <div><strong>Internal Diameter:</strong> <span>{state.size_and_quantity.diameter}mm</span></div>
                        <div><strong>Internal Height:</strong> <span>{state.size_and_quantity.height}mm</span></div>
                        <div><strong>Quantity:</strong> <span>{state.size_and_quantity.quantity}</span></div>
                    </div>

                    <div class="unit-price">
                        <span>Unit Price</span>
                        <span>£{choice[`${state.size_and_quantity.quantity}_unit_price`]}</span>
                    </div>

                    <hr></hr>

                    <div class="total-price">
                        <span>Total Price</span>
                        <span>£{totalPrice} + VAT</span>
                    </div>
                </div>
            </div>
            <div className='tab__actions'>
                <button className='btn' onClick={() => setTab('packaging')}>Back</button>
                <button className='btn' onClick={addToBasket} disabled={isSubmitting}>{isSubmitting ? 'adding...' : 'Add to Basket'}</button>
            </div>
        </div>
    )
}

export default Summary
